import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Content from '../Category/Content/Content'
import Nav2 from '../Nav2/Nav2'

const LihatSemuaCarousel1 = () => {
    const [content, setContent] = useState([])

    const fetchCarousel1 = async () => {
        const { data } = await axios.get(
            'https://weshare-heroku.herokuapp.com/api/weShare/category/urgent'
        )
        setContent(data.data)
    }

    useEffect(() => {
        fetchCarousel1()
    }, [])

    return (
        <div>
            <Nav2/>
            {
                content && content.map((c) => (
                    <Content
                        key={c.id}
                        name={c.donationName}
                        need={c.donationNeeded}
                        expired={c.expiredDate}
                        image={c.image}
                    />
                ))
            }
        </div>
    )
}

export default LihatSemuaCarousel1
